/**
 * The extension entity type names, as a literal. Kept apart from the schema map in `index.ts` so code that only
 * needs the names (`entityTypeNames`, the element lists) does not bundle every entity schema (GH #2294).
 * `entity-names.test.ts` checks it against the map.
 */
export const extensionEntityNames = [
  'agent',
  'audioclip',
  'audiocomment',
  'audiotrack',
  'song',
  'midi',
  'melody',
  'bandspace',
  'calendar',
  'calendarevent',
  'musicxml',
  'usersettings',
  'effect',
  'setlist',
  'pollresponse',
  'poll',
  'rider',
  'gear',
  'game',
  'gameresult',
  'gameboard',
  'musicreview',
] as const

export type ExtensionEntityName = (typeof extensionEntityNames)[number]
